import { createSlice } from "@reduxjs/toolkit";
import { getUser } from "./userApi";
import { toast } from "react-toastify";
import { getAnomalyForPerformerUser } from "../anomalyRegistration/anomalyApi";



export const userSlice = createSlice({
    name: 'user',
    initialState: {
        id: 0,
        username: "",
        isStaff: false,
        firstName: "",
        lastName: "",
        patronymic: "",
        workExperience: 0,
        post: "",
        tasks: null,
    },
    reducers: {
        reset: (state) => {
            state.username = ""
            state.isStaff = false
            state.firstName = ""
            state.lastName = ""
            state.patronymic = ""
            state.workExperience = 0
            state.post = ""
            state.isServiceMaintaince = false
            state.tasks = null
            state.isExists =false
        },

        resetTasks: (state) => {
            state.tasks = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUser.fulfilled, (state, action) => {
            state.id = action.payload.id
            state.username = action.payload.username
            state.isStaff = action.payload.is_staff
            state.firstName = action.payload.first_name
            state.lastName = action.payload.last_name
            state.patronymic = action.payload.patronymic
            state.workExperience = action.payload.work_experience
            state.post = action.payload.post
            state.isServiceMaintaince = action.payload.is_service_maintaince
        })
        builder.addCase(getUser.pending, (state, action) => {

        })

        builder.addCase(getUser.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                reset()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        })


        builder.addCase(getAnomalyForPerformerUser.fulfilled, (state, action) => {
            state.tasks = action.payload

        })
        builder.addCase(getAnomalyForPerformerUser.pending, (state, action) => {
        })

        builder.addCase(getAnomalyForPerformerUser.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 401"){
                localStorage.clear()
                message = "Нужно авторизоваться!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });

        })
    }
})


export const { reset } = userSlice.actions

export default userSlice.reducer
